import * as Types from 'apps/shared/scripts/__generated__/graphql.generated';

import { gql } from '@apollo/client';
import { InvoiceFragmentDoc } from '../../fragments/InvoiceFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpgradeCardMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  input: Types.TransactionInput;
}>;


export type UpgradeCardMutationResult = { readonly __typename: 'Mutation', readonly upgradeCard: { readonly __typename: 'Invoice', readonly cardId: string, readonly cardRecipient: string, readonly createdAt: any, readonly currencyCode: string, readonly id: string, readonly invoiceNumber: number, readonly status: string, readonly transactionId: string, readonly transactionTimestamp: any, readonly updatedAt: any, readonly userId: string, readonly customer: { readonly __typename: 'TransactionCustomer', readonly email: string, readonly address: { readonly __typename: 'TransactionAddress', readonly countryCode: string, readonly postalCode?: string | null, readonly city?: string | null, readonly region?: string | null, readonly firstLine?: string | null, readonly secondLine?: string | null } }, readonly item: { readonly __typename: 'TransactionItem', readonly id: string, readonly name?: string | null, readonly price: string }, readonly payment: { readonly __typename: 'TransactionPayment', readonly method: string, readonly card?: { readonly __typename: 'TransactionCard', readonly type?: string | null, readonly last4?: string | null } | null }, readonly totals: { readonly __typename: 'TransactionTotals', readonly subtotal: string, readonly tax: string, readonly discount: string, readonly total: string, readonly grandTotal: string } } };


export const UpgradeCardDocument = gql`
    mutation UpgradeCard($id: ID!, $input: TransactionInput!) {
  upgradeCard(id: $id, input: $input) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentDoc}`;
export type UpgradeCardMutationFn = Apollo.MutationFunction<UpgradeCardMutationResult, UpgradeCardMutationVariables>;

/**
 * __useUpgradeCardMutation__
 *
 * To run a mutation, you first call `useUpgradeCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeCardMutation, { data, loading, error }] = useUpgradeCardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpgradeCardMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeCardMutationResult, UpgradeCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeCardMutationResult, UpgradeCardMutationVariables>(UpgradeCardDocument, options);
      }
export type UpgradeCardMutationHookResult = ReturnType<typeof useUpgradeCardMutation>;
export type UpgradeCardMutationOptions = Apollo.BaseMutationOptions<UpgradeCardMutationResult, UpgradeCardMutationVariables>;